import React, { useState } from "react";
import {
  TimeBlockBody,
  TimeBlockDrawerProps,
} from "../../timeblock/TimeBlockDrawer";
import type { TimeBlockEvent } from "../../../../../types/calendar";
import { MobileFullScreen } from "./MobileFullScreen";
import { MobileSheet } from "./MobileSheet";

export type MobileTimeBlockSheetProps = Omit<
  TimeBlockDrawerProps,
  "nested" | "onOpenNested" | "onCloseNested"
>;

/**
 * Mobile time block bottom sheet: the desktop drawer's form (staff, type
 * tiles, description, start / end, Repeat, conflicts, series scopes) in a
 * MobileSheet; Repeat opens as a full-screen push. Escape backs out of
 * Repeat before closing the sheet. Replaces the legacy full-screen modal.
 */
export const MobileTimeBlockSheet: React.FC<MobileTimeBlockSheetProps> = (
  props,
) => {
  const { opened, onClose, isEdit, initialData } = props;
  const [nested, setNested] = useState<"repeat" | null>(null);
  const close = () => {
    setNested(null);
    onClose();
  };
  const key = isEdit
    ? ((initialData as TimeBlockEvent | null)?.id ?? "edit")
    : "new";
  return (
    <MobileSheet
      opened={opened}
      onClose={close}
      title={isEdit ? "Edit time block" : "New time block"}
      closeOnEscape={false}
      onKeyDown={(e) => {
        if (e.key !== "Escape" || e.defaultPrevented) return;
        // A modal on top (series scope) owns Escape.
        if (document.querySelector(".mantine-Modal-content")) return;
        e.preventDefault();
        e.stopPropagation();
        if (nested) setNested(null);
        else close();
      }}
      data-testid="mobile-time-block-sheet"
    >
      {opened && (
        <TimeBlockBody
          key={key}
          {...props}
          onClose={close}
          variant="sheet"
          nested={nested}
          onOpenNested={() => setNested("repeat")}
          onCloseNested={() => setNested(null)}
          nestedLayer={MobileFullScreen}
        />
      )}
    </MobileSheet>
  );
};
